import {ComponentTypes} from "../types";
import {three as threeTypes} from "../../../types";
import {createGumball} from "../gumball";
import {MeshResolution} from "../../const";
import {Calc} from "../../calc";
import {Param_Mesh, ParamTitles} from "../../parameter";
import {WompMesh} from "../../../WompObject";
import {getMeshDataFromThreeGeometry} from "../../../converter";
import {mat4, vec3} from "gl-matrix";
import {BasicMeshGenerator} from "./basic-gen";

export class ThreeConeGenerator extends BasicMeshGenerator {
  static defaultParameter = {
    radius: 10,
    height: 20
  };
  static draggingPreview = ThreeConeGenerator.generateMesh();

  static create() {
    let calc = createGumball();
    calc.component = ComponentTypes.ThreeConeGenerator;
    calc.title = 'cone';

    let coneParam = Param_Mesh.create(calc, ParamTitles.Cone, false, false, true);

    calc.addParameter(coneParam);

    return calc;
  }

  static getDesc(calc: Calc) {
    return 'cone';
  }

  static generateMesh(parameter: any = this.defaultParameter) {
    let value: threeTypes.BufferGeometry = new threeTypes.ConeBufferGeometry(
      this.defaultParameter.radius,
      this.defaultParameter.height,
      MeshResolution,
      MeshResolution / 1.5
    );

    value.rotateX(Math.PI / 2);

    let geom = getMeshDataFromThreeGeometry(value);

    return new WompMesh(geom, this.generateMatrix(parameter));
  }

  static generateMatrix(parameter: any = this.defaultParameter) {
    return mat4.fromScaling(
      mat4.create(),
      vec3.fromValues(
        parameter.radius / this.defaultParameter.radius,
        parameter.radius / this.defaultParameter.radius,
        parameter.height / this.defaultParameter.height
      )
    );
  }
}
